<mat-grid-list [cols]="showAccountInput()" rowHeight="125px">
  <mat-grid-tile colspan="3">
    <mat-form-field [style.width]="'98%'">
      <mat-label>Search by Key Name</mat-label>
      <input matInput placeholder="Search by Key Name" [formControl]="filter" />
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field [hideRequiredMarker]="hideRequired()" [floatLabel]="floatLabel()" [style.width]="'95%'">
      <mat-select [formControl]="showExpiredKeys">
        <mat-option [value]="true">Show Expired Keys</mat-option>
        <mat-option [value]="false">Hide Expired Keys</mat-option>
      </mat-select>
      <mat-label>Show Expired Keys</mat-label>
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field [hideRequiredMarker]="hideRequired()" [floatLabel]="floatLabel()" [style.width]="'95%'">
      <mat-select [formControl]="byAccount">
        <mat-option [value]="false">List Keys by User</mat-option>
        <mat-option [value]="true">List Keys by Customer Number</mat-option>
      </mat-select>
      <mat-label>Keys by User or Customer</mat-label>
    </mat-form-field>
  </mat-grid-tile>
  @if (byAccount.value) {
  <mat-grid-tile colspan="2">
    <mat-form-field [style.width]="'98%'">
      <mat-label>Customer Number</mat-label>
      <input matInput placeholder="Customer Number" [formControl]="customerNumber" />
    </mat-form-field>
  </mat-grid-tile>
  }
  <mat-grid-tile>
    <div class="rh-btn-container">
      <button class="rh-list-btn" mat-button (click)="fetchKeys()">List Keys</button>
    </div>
  </mat-grid-tile>
</mat-grid-list>